const dNodes = [
  {
    id: 0,
    index: 0,
    x: 729.8954380912653,
    y: 325.5933131704017,
    vy: -6.668127905329716e-05,
    vx: -0.0015576904656646308,
  },
  {
    id: 1,
    index: 1,
    x: 718.6002644493917,
    y: 358.2345189321034,
    vy: 0.0001468420232967225,
    vx: -0.0010157331750633438,
  },
  {
    id: 2,
    index: 2,
    x: 661.1671870495487,
    y: 323.03283642747886,
    vy: 6.325632216844385e-05,
    vx: -0.001116113179558696,
  },
  {
    id: 3,
    index: 3,
    x: 696.3568765626214,
    y: 298.95595659849147,
    vy: 3.479312508028476e-05,
    vx: -0.001669748560713508,
  },
  {
    id: 4,
    index: 4,
    x: 701.0372517597403,
    y: 327.10866965786033,
    vy: 3.7211680711222226e-05,
    vx: -0.0015292626199551948,
  },
  {
    id: 5,
    index: 5,
    x: 504.6966782285541,
    y: 259.39647937977577,
    vy: -0.00017865634517294342,
    vx: -0.001237588491801228,
  },
  {
    id: 6,
    index: 6,
    x: 686.7220051103592,
    y: 356.4364800842763,
    vy: 0.00040483432434552013,
    vx: -0.001623510655336494,
  },
  {
    id: 7,
    index: 7,
    x: 596.3040547727287,
    y: 286.96289566198305,
    vy: 4.97100704062562e-05,
    vx: -0.0012910691591194671,
  },
  {
    id: 8,
    index: 8,
    x: 662.2123813389508,
    y: 364.4506367464473,
    vy: 0.0002713488698185224,
    vx: -0.0013582082340534137,
  },
  {
    id: 9,
    index: 9,
    x: 400.2895113074044,
    y: 346.4616602892682,
    vy: -0.00014303624602610826,
    vx: -0.0013354285910104568,
  },
  {
    id: 10,
    index: 10,
    x: 634.086906880493,
    y: 281.08254512562746,
    vy: -0.00013826931400872858,
    vx: -0.0014860838894014176,
  },
  {
    id: 11,
    index: 11,
    x: 621.6049310088655,
    y: 254.26340517366447,
    vy: -8.630306458623038e-05,
    vx: -0.001590424407934779,
  },
  {
    id: 12,
    index: 12,
    x: 341.9544432950393,
    y: 420.8743244287558,
    vy: 0.0001650429803919354,
    vx: -0.0014402652379787685,
  },
  {
    id: 13,
    index: 13,
    x: 359.5763685240533,
    y: 384.0615892023536,
    vy: 0.0001088163927574198,
    vx: -0.0013811555995106519,
  },
  {
    id: 14,
    index: 14,
    x: 331.9557516016413,
    y: 462.0162932266108,
    vy: 0.00033176222354612734,
    vx: -0.0015176311740817633,
  },
  {
    id: 15,
    index: 15,
    x: 305.6897690815906,
    y: 442.47145697312254,
    vy: 0.00036071502863046226,
    vx: -0.0015229432604696685,
  },
  {
    id: 16,
    index: 16,
    x: 539.5106904722525,
    y: 246.5438797112511,
    vy: -0.0006560766952615006,
    vx: -0.001449619696994197,
  },
  {
    id: 17,
    index: 17,
    x: 521.3814959256687,
    y: 293.1695742449559,
    vy: -0.00040840039536303876,
    vx: -0.0013980135951769002,
  },
  {
    id: 18,
    index: 18,
    x: 438.4450961741592,
    y: 213.09064963080672,
    vy: -0.0005928900994444738,
    vx: -0.0013180395819982038,
  },
  {
    id: 19,
    index: 19,
    x: 486.7031743484215,
    y: 291.70814521335745,
    vy: -0.0004516938908350662,
    vx: -0.001501601512531599,
  },
  {
    id: 20,
    index: 20,
    x: 517.8310432886976,
    y: 222.9069950581516,
    vy: -0.0004388516280069861,
    vx: -0.0015473041972161171,
  },
  {
    id: 21,
    index: 21,
    x: 457.2637248339743,
    y: 149.02073989495676,
    vy: -0.00041989274754441287,
    vx: -0.001063413969346886,
  },
  {
    id: 22,
    index: 22,
    x: 454.5969416560787,
    y: 110.4239089794129,
    vy: -0.0007949542441270297,
    vx: -0.0014868852778126686,
  },
  {
    id: 23,
    index: 23,
    x: 421.4726737401723,
    y: 33.45528636066377,
    vy: -0.0008365552262279307,
    vx: -0.000751676745313972,
  },
  {
    id: 24,
    index: 24,
    x: 403.7605974318684,
    y: 384.95750926315463,
    vy: -0.00014585320353414954,
    vx: -0.0014021964705774215,
  },
  {
    id: 25,
    index: 25,
    x: 371.0992666840963,
    y: 301.8466821966893,
    vy: -0.00017169966948211342,
    vx: -0.001496745285314607,
  },
  {
    id: 26,
    index: 26,
    x: 410.5737147520844,
    y: -47.929735261061964,
    vy: -0.0010997582783167916,
    vx: -0.00031712938113055326,
  },
  {
    id: 27,
    index: 27,
    x: 473.0772525956524,
    y: 226.842784047396,
    vy: 1.32645179415422e-05,
    vx: -0.0015798176574679317,
  },
  {
    id: 28,
    index: 28,
    x: 386.18825775496873,
    y: 244.25198361983365,
    vy: -0.0005422416280250941,
    vx: -0.0015458639585325786,
  },
  {
    id: 29,
    index: 29,
    x: 411.0355063397709,
    y: -89.4810608021424,
    vy: -0.0012569488161806742,
    vx: 0.00013136450924678414,
  },
  {
    id: 30,
    index: 30,
    x: 386.38516161602973,
    y: -13.062511129240324,
    vy: -0.0011693242583643755,
    vx: -0.0006995291500579973,
  },
  {
    id: 31,
    index: 31,
    x: 368.48520937547585,
    y: -59.15696853850421,
    vy: -0.0014659426257247793,
    vx: -0.0002746197104277182,
  },
];

const dLinks = [
  {
    source: 0,
    target: 1,
    index: 0,
  },
  {
    source: 1,
    target: 2,
    index: 1,
  },
  {
    source: 2,
    target: 0,
    index: 2,
  },
  {
    source: 2,
    target: 3,
    index: 3,
  },
  {
    source: 2,
    target: 4,
    index: 4,
  },
  {
    source: 2,
    target: 5,
    index: 5,
  },
  {
    source: 2,
    target: 6,
    index: 6,
  },
  {
    source: 2,
    target: 7,
    index: 7,
  },
  {
    source: 2,
    target: 8,
    index: 8,
  },
  {
    source: 5,
    target: 9,
    index: 9,
  },
  {
    source: 7,
    target: 10,
    index: 10,
  },
  {
    source: 7,
    target: 11,
    index: 11,
  },
  {
    source: 7,
    target: 5,
    index: 12,
  },
  {
    source: 9,
    target: 12,
    index: 13,
  },
  {
    source: 9,
    target: 13,
    index: 14,
  },
  {
    source: 12,
    target: 14,
    index: 15,
  },
  {
    source: 13,
    target: 12,
    index: 16,
  },
  {
    source: 12,
    target: 15,
    index: 17,
  },
  {
    source: 5,
    target: 16,
    index: 18,
  },
  {
    source: 5,
    target: 17,
    index: 19,
  },
  {
    source: 5,
    target: 18,
    index: 20,
  },
  {
    source: 5,
    target: 19,
    index: 21,
  },
  {
    source: 5,
    target: 20,
    index: 22,
  },
  {
    source: 5,
    target: 21,
    index: 23,
  },
  {
    source: 21,
    target: 18,
    index: 24,
  },
  {
    source: 21,
    target: 22,
    index: 25,
  },
  {
    source: 21,
    target: 23,
    index: 26,
  },
  {
    source: 9,
    target: 24,
    index: 27,
  },
  {
    source: 9,
    target: 25,
    index: 28,
  },
  {
    source: 23,
    target: 26,
    index: 29,
  },
  {
    source: 5,
    target: 27,
    index: 30,
  },
  {
    source: 27,
    target: 18,
    index: 31,
  },
  {
    source: 18,
    target: 28,
    index: 32,
  },
  {
    source: 25,
    target: 28,
    index: 33,
  },
  {
    source: 26,
    target: 29,
    index: 34,
  },
  {
    source: 23,
    target: 30,
    index: 35,
  },
  {
    source: 26,
    target: 31,
    index: 36,
  },
  {
    source: 30,
    target: 31,
    index: 37,
  },
];

export { dNodes, dLinks };
